import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'
import type {TCardData} from '@kapitalist/contract/types'

export type TInspectingCard = {
  data: TCardData
  flipped: boolean
}

export type UIState = {
  inspectingCard: TInspectingCard | undefined
}

const initialState: UIState = {
  inspectingCard: undefined,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setInspectingCard(
      state: UIState,
      action: PayloadAction<TInspectingCard | undefined>
    ) {
      return {inspectingCard: action.payload}
    },
  },
})

const {setInspectingCard} = uiSlice.actions
export {setInspectingCard}
export default uiSlice.reducer
